import { AuthenticationMethod } from "@microsoft/microsoft-graph-types";
import { graphApi } from "@services/api/graphApi";
import { portalApi } from "@services/api/portalApi";

export type InductionProgress = {
    dateInductionStarted: string | null;
    details: string | null;
    wifi: string | null;
    authenticator: string | null;
    portal: string | null;
    outlook: string | null;
    teams: string | null;
    consent: string | null;
    photoMarketingConsent: boolean | null;
    dateInductionCompleted: string | null;
};

export async function getAuthenticationMethods(): Promise<AuthenticationMethod[]> {
    try {
        const response = await graphApi.get("/me/authentication/methods");
        console.log("Fetched authentication methods:", response.data.value);
        return response.data.value as AuthenticationMethod[];
    } catch (error) {
        console.error("Error fetching authentication methods:", error);
        throw error;
    }
}

export async function getInductionProgress(): Promise<InductionProgress> {
    return (await portalApi.get<InductionProgress>("/me/induction")).data;
}

export async function startInduction(): Promise<InductionProgress> {
    return (await portalApi.put<InductionProgress>("/me/induction/start")).data;
}

export type CompleteInductionStepInput = {
    step: string;
    photoMarketingConsent?: boolean;
};

export async function completeInductionStep({ step, photoMarketingConsent }: CompleteInductionStepInput): Promise<InductionProgress> {
    return (await portalApi.put<InductionProgress>(`/me/induction/steps/${step}`, { photoMarketingConsent })).data;
}
